import { JAVA_API_STATUS } from '../../utils/axios-interceptor';
import { toast } from 'react-toastify';

import {
    fetchCompanyMetricsService,
    fetchDebtProductsDataService,
    fetchCompanyDealMetrics,
    updateCompanyMetricsService,
    fetchMandateData,
    fetchAggregatedMandateData,
} from './service_debtProducts';
import { CompanyDealMetricsData } from '../../modules/DebtProducts/debtProductTypes';

export async function getCompanyMetrics(payload: { assesseeOrgId: string; dataSource?: string }) {
    try {
        let response = await fetchCompanyMetricsService(payload);
        const responseData = response?.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                return {
                    companyMetrics: response?.data?.companyMetrics || {},
                    percentageCompletion: response?.data?.percentageCompletion,
                    userName: response?.data?.userName,
                };
            case JAVA_API_STATUS.ERROR:
                toast.error(responseData?.responseMessage || 'Some error occurred');
                return null;
        }
    } catch (err) {
        console.error('Error in fetching company metrics', err);
        return null;
    }
}

export async function updateCompanyMetrics(payload: { orgId: string; parentOrgId: string; companyMetrics: Object }) {
    try {
        let response = await updateCompanyMetricsService(payload);
        const responseData = response?.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                return response?.data?.data || {};
            case JAVA_API_STATUS.ERROR:
                toast.error(responseData?.responseMessage || 'Some error occurred');
                return null;
        }
    } catch (err) {
        console.error('Error in updating company metrics', err);
        return null;
    }
}

export async function getDebtProductsData(payload: { orgId: string; aggregatorId: string; filters?: any; mandateId?: string }) {
    try {
        let response = await fetchDebtProductsDataService(payload);
        const responseData = response.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                return response?.data?.responseBody?.data || [];
            case JAVA_API_STATUS.ERROR:
            default:
                toast.error('Error in fetching debt products data');
                return [];
        }
    } catch (err) {
        console.error('Error in fetching debt products data', err);
        return [];
    }
}

/* 
    Fetch Company Metrics from Audited Financials
*/
export async function getCompanyDealMetrics(requestPayload: { requestPayload: CompanyDealMetricsData }) {
    try {
        let response = await fetchCompanyDealMetrics(requestPayload);
        const responseData = response?.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                return response?.data?.responseBody || {};
            case JAVA_API_STATUS.ERROR:
                toast.error(responseData?.responseMessage || 'Error while fetching company deal metrics');
                return null;
        }
    } catch (err) {
        console.error('Error in fetching company deal metrics', err);
        return null;
    }
}

export async function getMandateData(requestPayload: { requestPayload: { dealId: string; aggregated: boolean } }, handlers) {
    try {
        let response = await fetchMandateData(requestPayload);
        const responseData = response?.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                handlers?.onSuccess?.(response?.data?.responseBody || {});
                break;
            case JAVA_API_STATUS.ERROR:
                handlers?.onError?.();
                break;
        }
    } catch (err) {
        console.error('Error in fetching mandate data', err);
        handlers?.onError?.();
    }
}

export async function getAggregatedMandateData(dealId: string, handlers) {
    try {
        let response = await fetchAggregatedMandateData(dealId);
        const responseData = response?.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                handlers?.onSuccess?.(response?.data?.responseBody?.data || {});
                break;
            case JAVA_API_STATUS.ERROR:
                handlers?.onError?.();
                break;
        }
    } catch (err) {
        handlers?.onError?.();
    }
}
